/**
 * i18n routing configuration.
 *
 * Defines the supported locales and the default fallback locale.
 * No URL-prefix routing is used — locale is cookie-based only.
 *
 * `defaultLocale` is read from the NEXT_PUBLIC_DEFAULT_LOCALE env var so it
 * can be changed in .env without touching code. Falls back to "es" (the
 * Oficina virtual is Spanish-first) if the var is missing or unsupported.
 *
 * When the Admin Settings Page feature ships, this value will be superseded by
 * the site_settings table via a public API endpoint.
 */

export const locales = ["en", "es", "de"] as const;
export type Locale = (typeof locales)[number];

const envLocale = process.env.NEXT_PUBLIC_DEFAULT_LOCALE;
export const defaultLocale: Locale =
  envLocale && (locales as readonly string[]).includes(envLocale)
    ? (envLocale as Locale)
    : "es";
